import {
  Account,
  AccountBalance,
  AccountCreateRequest,
  AccountId,
  AccountRequest,
  ApiResponse,
  OfferingId,
  OfferingMonthlyBalance,
  OfferingTransaction,
  TotalAvailableSharesResponse,
  TradesQueryFilters,
  UserId,
} from '@arrived/models';

import { api } from './api';
import { getQueryStringFromFilters, unwrapApiResponse } from './utils';

export const getUserAccounts = async (userId: UserId) => {
  const response = await api.get<ApiResponse<Account[]>>(`/users/${userId}/accounts`);

  return unwrapApiResponse(response.data);
};

export const getUserAccount = async (accountId: AccountId) => {
  const response = await api.get<ApiResponse<Account>>(`/users/accounts/${accountId}`);

  return unwrapApiResponse(response.data);
};

export const postUserAccount = async (userAccountCreateRequest: AccountCreateRequest) => {
  const response = await api.post<ApiResponse<Account>>('/users/accounts', userAccountCreateRequest);

  return unwrapApiResponse(response.data);
};

export const patchUserAccount = async (userAccountRequest: AccountRequest) => {
  const response = await api.patch<ApiResponse<Account>>(
    `/users/accounts/${userAccountRequest.id}`,
    userAccountRequest
  );

  return unwrapApiResponse(response.data);
};

export const deleteUserAccount = async (accountId: AccountId) => {
  const response = await api.delete<ApiResponse<Account>>(`/users/accounts/${accountId}`);

  return unwrapApiResponse(response.data);
};

export const getAccountTaxId = async (accountId: AccountId) => {
  const response = await api.get<ApiResponse<string>>(`/users/accounts/${accountId}/tax-id`);

  return unwrapApiResponse(response.data);
};

export const getUserAccountBalance = async (accountId: AccountId) => {
  const response = await api.get<ApiResponse<AccountBalance>>(`/users/accounts/${accountId}/balance`);

  return unwrapApiResponse(response.data);
};

export const getUserAccountMonthlyBalance = async (accountId: AccountId) => {
  const response = await api.get<ApiResponse<OfferingMonthlyBalance[]>>(`/users/accounts/${accountId}/balance/monthly`);

  return unwrapApiResponse(response.data);
};

export const getSharesAvailableForAccount = async (accountId: AccountId, offeringId: OfferingId) => {
  const response = await api.get<ApiResponse<TotalAvailableSharesResponse>>(
    `/users/accounts/${accountId}/offerings/${offeringId}/shares/available`
  );

  return unwrapApiResponse(response.data);
};

export const getAccountTrades = async (accountId: AccountId, filters?: TradesQueryFilters) => {
  const queryParameters = filters ? getQueryStringFromFilters<TradesQueryFilters>(filters) : '';

  const response = await api.get<ApiResponse<OfferingTransaction[]>>(
    `/users/accounts/${accountId}/trades${queryParameters}`
  );

  return unwrapApiResponse(response.data);
};
